import React from "react";
import ReactDOM from "react-dom";
import { Catalog, pageLoader } from "catalog";

const pages = [
  {
    path: "/",
    title: "Introduction",
    content: pageLoader(() => import("./Pages/About/welcome.md"))
  },
  {
    path: "/design-principles",
    title: "Our Design Principles",
    content: pageLoader(() => import("./Pages/About/design-principles.md"))
  },
  {
    path: "/basics",
    title: "Basic Use",
    content: pageLoader(() => import("./Pages/Guidelines/basics.md"))
  },
  {
    path: "/ui-colors",
    title: "UI Colors",
    content: pageLoader(() => import("./Pages/Guidelines/colors.md"))
  },
  {
    path: "/atoms/buttons",
    title: "Buttons",
    content: pageLoader(() => import("./Pages/Atoms/buttons.md"))
  },
  {
    path: "/molecules/button-dropdown",
    title: "Button Dropdown",
    content: pageLoader(() => import("./Pages/Molecules/button-dropdown.md"))
  },
  {
    path: "/molecules/button-group",
    title: "Button Groups",
    content: pageLoader(() => import("./Pages/Molecules/button-group.md"))
  },
  {
    path: "/organisms/calendar",
    title: "Calendar",
    content: pageLoader(() => import("./Pages/Organisms/calendar.md"))
  },
  {
    path: "/molecules/card",
    title: "Cards",
    content: pageLoader(() => import("./Pages/Molecules/cards.md"))
  },
  {
    path: "/organisms/cards-list",
    title: "Card List",
    content: pageLoader(() => import("./Pages/Organisms/cards-list.md"))
  },
  {
    path: "/atoms/checkbox",
    title: "Checkbox",
    content: pageLoader(() => import("./Pages/Atoms/checkbox.md"))
  },
  {
    path: "/atoms/containers",
    title: "Container",
    content: pageLoader(() => import("./Pages/Atoms/containers.md"))
  },
  {
    path: "/atoms/data",
    title: "Data",
    content: pageLoader(() => import("./Pages/Atoms/data.md"))
  },
  {
    path: "/molecules/data-set",
    title: "Data Set",
    content: pageLoader(() => import("./Pages/Molecules/data-set.md"))
  },
  {
    path: "/organisms/desktop-navigation",
    title: "Desktop Navigation",
    content: pageLoader(() => import("./Pages/Organisms/desktop-navigation.md"))
  },
  {
    path: "/organisms/full-page-prompts",
    title: "Full Page Prompts",
    content: pageLoader(() => import("./Pages/Patterns/full-page-prompts.md"))
  },
  {
    path: "/molecules/empty-state",
    title: "Empty State",
    content: pageLoader(() => import("./Pages/Molecules/empty-state.md"))
  },
  {
    path: "/atoms/file-input",
    title: "File Input",
    content: pageLoader(() => import("./Pages/Atoms/file-input.md"))
  },
  {
    path: "/atoms/icons",
    title: "Icons",
    content: pageLoader(() => import("./Pages/Atoms/icons.md"))
  },
  {
    path: "/organisms/inner-navigation",
    title: "Inner Navigation",
    content: pageLoader(() => import("./Pages/Organisms/inner-navigation.md"))
  },
  {
    path: "/molecules/input-group",
    title: "Input Group",
    content: pageLoader(() => import("./Pages/Molecules/form-group.md"))
  },
  {
    path: "/atoms/input",
    title: "Input Field",
    content: pageLoader(() => import("./Pages/Atoms/input.md"))
  },
  {
    path: "/atoms/loading",
    title: "Loading States",
    content: pageLoader(() => import("./Pages/Atoms/loading-states.md"))
  },
  {
    path: "/organisms/mobile-tabs",
    title: "Mobile Tabs",
    content: pageLoader(() => import("./Pages/Organisms/mobile-navigation.md"))
  },
  {
    path: "/molecules/modal",
    title: "Modal",
    content: pageLoader(() => import("./Pages/Molecules/modal.md"))
  },
  {
    path: "/molecules/notice",
    title: "Notice",
    content: pageLoader(() => import("./Pages/Molecules/notice.md"))    
  },
  {
    path: "/molecules/banner",
    title: "Notice Banner",
    content: pageLoader(() => import("./Pages/Molecules/notice-banner.md"))
  },
  {
    path: "/atoms/progress-bar",
    title: "Progress / Percentage Bar",
    content: pageLoader(() => import("./Pages/Atoms/progress-bar.md"))
  },
  {
    path: "/atoms/radio",
    title: "Radio",
    content: pageLoader(() => import("./Pages/Atoms/radio.md"))
  },
  {
    path: "/atoms/section-separator",
    title: "Section Separator",
    content: pageLoader(() => import("./Pages/Atoms/section-separator.md"))
  },
  {
    path: "/atoms/select",
    title: "Select",
    content: pageLoader(() => import("./Pages/Atoms/select.md"))
  },
  {
    path: "/atoms/status",
    title: "Status / Tags",
    content: pageLoader(() => import("./Pages/Atoms/status.md"))
  },
  {
    path: "/organisms/step-sequence",
    title: "Step Sequence",
    content: pageLoader(() => import("./Pages/Organisms/step-sequence.md"))
  },
  {
    path: "/atoms/textarea",
    title: "TextArea",
    content: pageLoader(() => import("./Pages/Atoms/textarea.md"))
  },
  {
    path: "/atoms/typography",
    title: "Text / Typography",
    content: pageLoader(() => import("./Pages/Atoms/typography.md"))
  }

];


ReactDOM.render(
  <Catalog 
    title="First Circle / Design System"
    pages={pages}
    //logoSrc="/fcds_logo.svg"
    styles={["/style.css"]}
    responsiveSizes={[
      {name: 'mobile', width: 320, height: 480},
      {name: 'tablet', width: 800, height: 600},
      {name: 'desktop', width: 1024, height: 768}
    ]}
    theme={
      {
        pageHeadingHeight: 145,
        textColor: "#484848",
        background: "#fff",
        brandColor: "#484848",
        linkColor: "#1b8df2",

        //Page Headings
        pageHeading: { Background: "#0067db", TextColor: "#fff" },
        pageHeadingBackground: "#0067db",
        pageHeadingTextColor: "#fff",
        
        fontFamily: "'Hind Madurai', sans-serif",
        fontHeading: "'Averta Semibold', sans-serif",
        fontMono: "'IBM Plex Mono', monospace",
        sidebarColorHeading: "#0067db",
        sidebarColorTextActive: "#1b8df2",
        sidebarColorActive: "#0067db",
        sidebarColorText: "#484848",
      }
    }
  />,
  document.getElementById("catalog")
)



// WEBPACK FOOTER //
// ./catalog/index.js